<template>
    <div>
        <component :is="selectComponent" :sellerData="sellerData"></component>
    </div>
</template>
<script>
    import axios from 'axios';
    import config from '@/config/config';
    export default {
        data() {
            return {
                selectComponent: '',
                sellerData: {}
            }
        },
        components: {
            store: () => import('./components/store.vue'),
            privacyPlicy: () => import('./components/privacy_policy.vue'),
            returnAndRefund: () => import('./components/return_and_refund.vue'),
            termsOfUsage: () => import('./components/terms_of_usage.vue'),
        },
        methods: {
            getMobileOperatingSystem() {
                var userAgent = navigator.userAgent || navigator.vendor || window.opera;
                if (/windows phone/i.test(userAgent)) {
                    return "Windows Phone";
                }
                if (/android/i.test(userAgent)) {
                    return "Android";
                }
                if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    return "iOS";
                }
                return "unknown";
            },
            openAppUrl() {
                var deviceType = this.getMobileOperatingSystem();
                if(deviceType == 'Android' && this.sellerData != null && this.sellerData.android_app_url != '') {
                    window.location.href = this.sellerData.android_app_url;
                
                } else if(deviceType == 'iOS' && this.sellerData != null && this.sellerData.apple_app_url != '') {
                    window.location.href = this.sellerData.apple_app_url;
                } 
            },
            init() {
                if(this.sellerData != null) {
                    var urlString = window.location.href; 
                    var url = new URL(urlString);
                    var product = url.searchParams.get("p");
                    var category = url.searchParams.get("c");
                    var order = url.searchParams.get("o");
                    if(product != null)  {
                        var appOpen = window.location.replace(this.sellerData.store_code+'://p='+product);
                        if(typeof appOpen === "undefined") this.openAppUrl(); 
    
                    } else if(category != null) {
                        var appOpen = window.location.replace(this.sellerData.store_code+'://c='+category);
                        if(typeof appOpen === "undefined") this.openAppUrl();   
                    
                    } else if(order != null) {
                        var appOpen = window.location.replace(this.sellerData.store_code+'://o='+order);
                        if(typeof appOpen === "undefined") this.openAppUrl(); 
    
                    }
                }
            }
        },
        async created() {
            var url = window.location.href;
            var store_code = url.split('/')[config.code_postion];
            var policy = url.split('/')[config.code_postion + 1];

            if(store_code != '') {
                try {
                    var response = await axios.get(config.file_url+store_code+'.json');
                    if(response != null || response.hasOwnProperty('data')) {
                        response.data.store_code = store_code;
                        this.sellerData = response.data;
                        this.selectComponent = 'store';
                        this.init();
                        document.title = this.sellerData.name;

                        if(policy != "undefined") {
                            if(policy == "privacy-policy") this.selectComponent = "privacyPlicy";
                            else if(policy == "return-and-refund") this.selectComponent = "returnAndRefund";
                            else if(policy == "terms-of-usage") this.selectComponent = "termsOfUsage";
                        }
                    } else {
                        // window.location.href = config.website_url;
                    } 
                } catch(error) {
                    // window.location.href = config.website_url;
                }
            }
        }
    }
</script>